import { useEffect, useState } from 'react';
import { BrowserInfo } from '../types';
import { UAParser } from 'ua-parser-js';

export const useBrowserInfo = () => {
  const [info, setInfo] = useState<BrowserInfo>({
    ip: '',
    browser: '',
    os: '',
    userAgent: '',
    acceptLanguage: ''
  });

  useEffect(() => {
    const parser = new UAParser();
    const result = parser.getResult();

    fetch(`${process.env.REACT_APP_IP_ADDRESS_LOCATOR}`)
      .then(res => res.json())
      .then(data => {
        setInfo({
          ip: data.ip,
          browser: result.browser.name ?? '',
          os: result.os.name ?? '',
          userAgent: navigator.userAgent,
          acceptLanguage: navigator.languages.join(",")
        });
      }).catch((error) => {
        setInfo({
          ip: '127.0.0.1',
          browser: result.browser.name ?? 'Chrome',
          os: result.os.name ?? 'MacOS',
          userAgent: navigator.userAgent,
          acceptLanguage: navigator.languages.join(",")
        });
      });
  }, []);

  return { browserInfo: info };
}
